import React from 'react';
import Hero from '../components/Hero';
import Gallery from '../components/Gallery';
import Artists from '../components/Artists';
import Services from '../components/Services';
import Booking from '../components/Booking';
import Reviews from '../components/Reviews';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <Gallery />
      <Artists />
      <Services />
      <Booking />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
